import type { ClassLocationApi } from "../../api/ClassLocationApi";
import type { ApClassFetchOptions } from "../../generated/dto/ApClassFetchOptions";
import type { ApClassStaff } from "../../generated/dto/ApClassStaff";
import type { ClassLocationFetchOptions } from "../../generated/dto/ClassLocationFetchOptions";
import type { ClassLocationStaff } from "../../generated/dto/ClassLocationStaff";
import type { CreateClassLocation } from "../../generated/dto/CreateClassLocation";
import type { DeleteClassLocationStaff } from "../../generated/dto/DeleteClassLocationStaff";
import type { JpClassFetchOptions } from "../../generated/dto/JpClassFetchOptions";
import type { JpClassStaff } from "../../generated/dto/JpClassStaff";
import type { UpdateClassLocation } from "../../generated/dto/UpdateClassLocation";

export class ClassLocationFrontendService {
  constructor(private readonly api: ClassLocationApi) {}
  async getClassLocationStaff(id: number, options?: ClassLocationFetchOptions): Promise<ClassLocationStaff> {
    return this.api.getClassLocationStaff(id, options)
  }
  async createClassLocationStaff(source: CreateClassLocation): Promise<ClassLocationStaff> {
    return this.api.createClassLocationStaff(source)
  }
  async updateClassLocationStaff(source: UpdateClassLocation): Promise<ClassLocationStaff> {
    return this.api.updateClassLocationStaff(source)
  }
  async deleteClassLocationStaff(source: DeleteClassLocationStaff): Promise<void> {
    return this.api.deleteClassLocationStaff(source)
  }
  async getClassLocationStaffApClasses(id: number, options?: ApClassFetchOptions): Promise<Array<ApClassStaff>> {
    return this.api.getClassLocationStaffApClasses(id, options)
  }
  async getClassLocationStaffJpClasses(id: number, options?: JpClassFetchOptions): Promise<Array<JpClassStaff>> {
    return this.api.getClassLocationStaffJpClasses(id, options)
  }
}
